"use client";

import { useCallback, useEffect, useMemo, useState } from "react";
import { MenuItem, Box, ListItemIcon, Button } from "@mui/material";

import BorderColorIcon from "@mui/icons-material/BorderColor";
import Divider from "@mui/material/Divider";

import PostAddIcon from "@mui/icons-material/PostAdd";
import AddIcon from "@mui/icons-material/Add";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import ManageSearchIcon from "@mui/icons-material/ManageSearch";
import { MRT_Localization_ES } from "material-react-table/locales/es";
import FilePresentIcon from "@mui/icons-material/FilePresent";
import MaterialReactTable from "material-react-table";
import { UrlApi } from "../../../../../services/apirest";
import { usePlanta } from "../../../context/PlantaContext";
import Tareas from "../../tareas/v2/Tareas";
import { EquipmentHistory } from "./equipment-history";
import { AddEquipmentForm } from "./add-equipment-form";
import Notify from "../../../../Notify";
import { EditEquipmentForm } from "./edit-equipment-form";
import { useApi } from "../../../hooks/useApi";
import { ENDPOINTS } from "../../../config/endpoints";
import { CorrectiveMaintenanceForm } from "../../correctivos/v2/corrective-maintenance-form";
import EquipmentDocumentationContainer from "./documents/documentacion-container";
import { useNavigate } from "react-router-dom";
import { PlantSelectionMessage } from "../../../utils/SeleccionPlantaMensaje";
import { useToast } from "../../../../../Hooks/UseToast";
export function EquipmentTable() {
  // Buscar por la planta que haya seleccionado el usuario
  const { plantaSeleccionada } = usePlanta();
  const { showToast, Toast } = useToast();
  const [equipos, setEquipos] = useState([]);
  const [rowData, setrowData] = useState([]);

  /**
   * @async @function getEquipos()
   *  @var @type {Number} PlantaSelecionada
   * @returns {equipos : [{}]}
   * trae  los equipos segun las plantas que seleccione el usuario en todo el modulo
   * y el callback es para que este dependiendo y llamando a la funcion solo en caso de que cambie la planta asi no hace cambios innecesarios
   *
   */
  const { get, loading, error } = useApi();

  const getEquipos = useCallback(async () => {
    try {
      if (plantaSeleccionada) {
        const data = await get(
          `${ENDPOINTS.EQUIPOS.BASE}/${plantaSeleccionada}`
        );
        setEquipos(data);
      }
    } catch (err) {
      console.error("Error al obtener equipos:", err);
    }
  }, [plantaSeleccionada, get]);
  useEffect(() => {
    getEquipos();
  }, [getEquipos, plantaSeleccionada]);

  /**
   * @function OpenDialogFormEquipo
   */
  //Dialogo de Formulario para agregar un equipo
  const [openAddForm, setOpenAddForm] = useState(false);
  const [openEditForm, setOpenEditForm] = useState(false);
  const opeAddFormEquipo = () => setOpenAddForm(true);
  const closeAddFormEquipo = () => setOpenAddForm(false);

  const openEditEquipo = () => {
    setOpenEditForm(true);
  };
  const closeEditFormEquipo = () => setOpenEditForm(false);

  // Estados para el diálogo de tareas
  const [tasksDialogOpen, setTasksDialogOpen] = useState(false);
  const [selectedEquipo, setSelectedEquipo] = useState(null);

  // Manejadores para el diálogo de tareas
  const handleOpenTasksDialog = (item) => {
    setSelectedEquipo(item);
    setTasksDialogOpen(true);
  };

  const handleCloseTasksDialog = () => {
    setTasksDialogOpen(false);
    setSelectedEquipo(null);
  };
  // Estados para el dialogo de agregar un  Correctivos
  const [openCorrectivo, setopenCorrectivo] = useState(false);

  const openCorrectivoForm = (equipo) => {
    setSelectedEquipo(equipo);
    setopenCorrectivo(true);
  };
  const closeCorrectivoForm = () => {
    setopenCorrectivo(false);
  };
  //Estado para historial del equipo
  const [openHistory, setopenHistory] = useState(false);
  const handleOpenHistory = (equipo) => {
    setSelectedEquipo(equipo);
    setopenHistory(true);
  };
  const handleCloseHistory = () => {
    setopenHistory(false);
  };
  //Estado para documentacion del equipo
  const navigate = useNavigate();
  const openDocumentacionForm = (equipo) => {
    navigate(`/mant_plantas/equipos/${equipo.id}/documentacion`, {
      state: { equipo },
    });
  };
  const columns = useMemo(
    () => [
      { header: "Id Equipo", accessorKey: "id", size: 100 },
      { header: "Id Origen", accessorKey: "id_origen", size: 110 },
      { header: "EquipoAnt", accessorKey: "serie_equipo", size: 180 },
      { header: "Nombre", accessorKey: "equipo" },
      { header: "Zona", accessorKey: "zona" },
      { header: "Sector", accessorKey: "sector", size: 100 },
      {
        header: "Critico",
        accessorKey: "critico",
        size: 110,
        Cell: ({ row }) => (row.original.critico ? "Si" : "No"), // Mostrar "Si" o "No" según este en estado critico en la BD se guarda como "estado critico" pero aqui lo mostramos como "Si" o "No"
      },
    ],
    []
  );
  const initialState = {
    density: "compact",
    showGlobalFilter: true,
    pagination: { pageIndex: 0, pageSize: 15 },
  };
  const muiSearchTextFieldProps = {
    placeholder: "Buscar..",
    sx: { minWidth: "18rem", backgroundColor: "#ffffff" },
    variant: "outlined",
    color: "primary",
    focused: true,
    size: "small",
  };
  const tableHeadCellProps = {
    align: "center",
    sx: {
      pt: 1,
      fontSize: 16,
      color: "white",
      fontWeight: "normal",
      backgroundColor: "#2471A3",
      borderColor: "black",
    },
  };

  return (
    <Box sx={{ mb: 4 }}>
      {Toast}
      {plantaSeleccionada ? (
        <MaterialReactTable
          localization={MRT_Localization_ES}
          columns={columns}
          data={equipos}
          layoutMode="grid"
          initialState={initialState}
          enableColumnActions={false}
          enableGlobalFilterModes={false}
          enableHiding={false}
          enableRowActions
          enableColumnFilters={false}
          enableStickyHeader
          enableStickyFooter
          enableGlobalFilter={false}
          enableFullScreenToggle={false}
          positionActionsColumn="last"
          enableExpandAll={false}
          enableToolbarInternalActions
          enableDensityToggle={false}
          enableColumnResizing
          muiTableHeadCellProps={tableHeadCellProps}
          muiSearchTextFieldProps={muiSearchTextFieldProps}
          displayColumnDefOptions={{
            "mrt-row-actions": {
              muiTableHeadCellProps: {
                align: "center",
              },
              muiTableBodyCellProps: {
                align: "center",
              },
            },
          }}
          muiTableBodyCellProps={() => ({
            align: "left",
            sx: {
              color: "black",
              borderColor: "black",
              whiteSpace: "balance",
              wordBreak: "break-word",
            },
          })}
          renderTopToolbarCustomActions={() => (
            <Box display="flex" justifyContent="flex-end" width="100%">
              <Button
                variant="contained"
                color="primary"
                onClick={opeAddFormEquipo}
                startIcon={<AddIcon />}
                size="small"
              >
                Agregar Equipo
              </Button>
            </Box>
          )}
          renderRowActionMenuItems={({ closeMenu, row }) => [
            <MenuItem
              key="editar"
              onClick={() => {
                setrowData(row.original);
                openEditEquipo();
                closeMenu();
              }}
              sx={{ m: 0 }}
            >
              <ListItemIcon>
                <BorderColorIcon color="primary" />
              </ListItemIcon>
              Editar
            </MenuItem>,
            <MenuItem
              key="tareas"
              onClick={() => {
                handleOpenTasksDialog(row.original);
                closeMenu();
              }}
              sx={{ m: 0 }}
            >
              <ListItemIcon>
                <AddCircleIcon color="primary" />
              </ListItemIcon>
              Tareas
            </MenuItem>,
            <MenuItem
              key="correctivo"
              onClick={() => {
                openCorrectivoForm(row.original);
                closeMenu();
              }}
              sx={{ m: 0 }}
            >
              <ListItemIcon>
                <PostAddIcon color="success" />
              </ListItemIcon>
              Agregar Correctivo
            </MenuItem>,
            <Divider key="divider" />,
            <MenuItem
              key="historial"
              onClick={() => {
                handleOpenHistory(row.original);
                closeMenu();
              }}
              sx={{ m: 0 }}
            >
              <ListItemIcon>
                <ManageSearchIcon color="info" />
              </ListItemIcon>
              Historial De Equipo
            </MenuItem>,
            <Divider key="divider" />,
            <MenuItem
              key="documentacion"
              onClick={() => {
                openDocumentacionForm(row.original);
                closeMenu();
              }}
              sx={{ m: 0 }}
            >
              <ListItemIcon>
                <FilePresentIcon color="primary" />
              </ListItemIcon>
              Documentacion
            </MenuItem>,
          ]}
        />
      ) : (
        <PlantSelectionMessage />
      )}

      {openAddForm ? (
        <AddEquipmentForm
          open={openAddForm}
          onClose={closeAddFormEquipo}
          refetch={getEquipos}
          showToast={showToast}
        />
      ) : null}
      {openEditForm ? (
        <EditEquipmentForm
          equipo={rowData}
          open={openEditForm}
          refetch={getEquipos}
          onClose={closeEditFormEquipo}
          showToast={showToast}
        />
      ) : null}
      {tasksDialogOpen ? (
        <Tareas
          selectedEquipo={selectedEquipo}
          handleCloseTasksDialog={handleCloseTasksDialog}
          tasksDialogOpen={tasksDialogOpen}
        />
      ) : null}
      {openHistory ? (
        <EquipmentHistory
          equipment={selectedEquipo}
          open={openHistory}
          onClose={handleCloseHistory}
        />
      ) : null}
      {openCorrectivo ? (
        <CorrectiveMaintenanceForm
          open={openCorrectivo}
          onClose={closeCorrectivoForm}
          refetch={getEquipos}
          equipment={selectedEquipo}
        />
      ) : null}
    </Box>
  );
}
